import type { ProjectDocument } from '@/lib/db/rxdb/schemas/project'
import { ProjectIcon } from '@/lib/utils/projectIcon'
import { cn } from '@/lib/utils'

type Located = Pick<ProjectDocument, 'name' | 'icon' | 'iconType' | 'iconColor' | 'parentProjectId'>

/**
 * The colour mark for a space or project (design 24a: each keeps its own
 * colour; terracotta is only the accent). Both are the lettered/icon badge, so
 * the collapsed sidebar rail still shows a glyph and not just a colour block.
 */
export function LocationSwatch({
  location,
  size = 14,
  className,
}: {
  location: Located
  size?: number
  className?: string
}) {
  return (
    <ProjectIcon
      iconType={location.iconType}
      icon={location.icon}
      iconColor={location.iconColor}
      size={size - 4}
      variant="badge"
      fallbackLabel={location.name}
      className={cn('shrink-0', className)}
    />
  )
}
